import { useState, useEffect } from 'react';

export function useSessionState<T>(key: string, defaultValue?: T): [T, (value: T) => void] {
  const [state, setState] = useState<T>(() => {
    const storedValue = localStorage.getItem(key);
    if (!storedValue) return defaultValue as T;
    try {
      return JSON.parse(storedValue) as T;
    } catch {
      return (storedValue as unknown as T) ?? (defaultValue as T);
    }
  });

  useEffect(() => {
    if (state === undefined || state === null) {
      localStorage.removeItem(key);
    } else if (typeof state === 'string') {
      localStorage.setItem(key, state);
    } else {
      localStorage.setItem(key, JSON.stringify(state));
    }
  }, [key, state]);

  return [state, setState];
}
